import React from "react";

function ExperienceCard({
  role,
  company,
  period,
  status,
  responsibilities = [],
  shadowColor = "#ccd5ae",
  hoverShadowColor = "#d4a373",
}) {
  return (
    <div
      style={{
        "--card-shadow": shadowColor,
        "--card-hover-shadow": hoverShadowColor,
      }}
      className="border-2 border-slate-900 bg-white rounded-2xl p-6 shadow-[6px_6px_0px_0px_var(--card-shadow)] hover:shadow-[10px_10px_0px_0px_var(--card-hover-shadow)] transition-all duration-300 flex flex-col md:flex-row md:items-start justify-between gap-6"
    >
      {/* Sisi Kiri: Informasi Peran & Instansi */}
      <div className="space-y-2 md:max-w-xs w-full shrink-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-mono font-bold uppercase tracking-widest text-gsf-bronze bg-gsf-sand/40 border border-gsf-bronze/20 px-2 py-0.5 rounded">
            {status}
          </span>
          <span className="text-xs font-bold text-slate-400">{period}</span>
        </div>
        <div>
          <h3 className="text-xl font-black text-slate-900 tracking-tight">
            {role}
          </h3>
          <p className="text-sm font-bold text-slate-600">{company}</p>
        </div>
      </div>

      {/* Sisi Kanan: Pokok Kontribusi Utama (Key Contributions) */}
      <div className="flex-1 border-t md:border-t-0 md:border-l border-slate-100 pt-4 md:pt-0 md:pl-6">
        <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 block mb-2">
          Key Contributions & Tech Deployed
        </span>
        <ul className="space-y-2">
          {responsibilities.map((item, index) => (
            <li
              key={index}
              className="text-xs sm:text-sm text-slate-600 font-medium flex items-start gap-2 leading-relaxed"
            >
              <span className="text-gsf-bronze shrink-0 mt-1">✦</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default ExperienceCard;
